'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextCheckbox = require('./TextCheckbox');

Object.keys(_TextCheckbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextCheckbox[key];
    }
  });
});